import http from 'conversations-http/clients/http';
export const fetchSpacesClient = () => http.get(`hd-spaces/v1/spaces`);